import React, { useRef } from 'react'
import { Form, Input, Select } from 'antd'
import { defaultApiKey } from '.';

const { Option } = Select;

const EnvOptions = [
    { _id: 'testing', label: 'Testing', value: 'testing' },
    { _id: 'staging', label: 'Staging', value: 'staging' },
    { _id: 'production', label: 'Production', value: 'production' }
]

interface Props {
    setEnvParams: any
    editData: any
}

const Environment: React.FC<Props> = (props) => {

    const formattedUrl = (inputValue: string) => {
        let formattedUrl = inputValue.replace(/[\/\\]+$/, '');
        return formattedUrl;
    };
    const inputRef = useRef<any>(null);
    const onFocusApiKey = () => {
        if (props.editData && inputRef.current && inputRef.current.state.value === defaultApiKey){
            inputRef.current.state.value = '';
            props.setEnvParams('apiKey', '');
        }
    }

    return (
        <div className={"row override-content"}>
            <div className={"col-md-12"}>
                <Form.Item label='Environment Name' required>
                    <Input data-test-id="env_name" placeholder="" defaultValue={props.editData && props.editData.name} onChange={(e: any) => props.setEnvParams('name', e.target.value)} />
                </Form.Item>
            </div>
            <div className={"col-md-12"}>
                <Form.Item label='Environment Type' required>
                    <Select data-test-id="env_type" defaultValue={props.editData && props.editData.type} style={{ width: '100%' }} onChange={(e: any) => props.setEnvParams('type', e)}>
                        {EnvOptions.map((data) => (
                            <Option data-test-id={data._id} value={data.value} key={data._id}>{data.label}</Option>
                        ))
                        }
                    </Select>
                </Form.Item>
            </div>
            <div className={"col-md-12"}>
                <Form.Item label='API Key' required>
                    <Input type="password" data-test-id="api_key" defaultValue={props.editData ? defaultApiKey : ""} placeholder="" onFocus={onFocusApiKey} ref={inputRef} onChange={(e: any) => props.setEnvParams('apiKey', e.target.value)} />
                </Form.Item>
            </div>
            <div className={"col-md-12"}>
                <Form.Item label='Domain URL' required>
                    <Input data-test-id="domain_url" defaultValue={props.editData && props.editData.url} placeholder="" onChange={(e: any) => props.setEnvParams('url', formattedUrl(e.target.value))} />
                </Form.Item>
            </div>
        </div>
    )
}


export default Environment;
